import React from 'react';
import { Cpu, Network, Zap } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Digital Transformation Leaders</h2>
          <p className="section-description">
            At the forefront of creating safer, more efficient, and hyper-connected environments
          </p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="about-icon-container">
              <Cpu className="about-icon" size={32} />
            </div>
            <h3 className="about-card-title">Advanced Hardware</h3>
            <p className="about-card-text">
              Cutting-edge technological frameworks that power the infrastructure 
              of tomorrow's smart ecosystems.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon-container">
              <Network className="about-icon" size={32} />
            </div>
            <h3 className="about-card-title">Intelligent Software</h3>
            <p className="about-card-text">
              AI-driven solutions that provide actionable insights and enable 
              seamless integration across all systems.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon-container">
              <Zap className="about-icon" size={32} />
            </div>
            <h3 className="about-card-title">Smart Integration</h3>
            <p className="about-card-text">
              Empowering organizations to transition into the smart era with 
              comprehensive, integrated solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
